(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('ProfessionalAreaGroup', ProfessionalAreaGroup);

    ProfessionalAreaGroup.$inject = ['$resource'];

    function ProfessionalAreaGroup ($resource) {
        var resourceUrl =  'api/professional-area-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
